import { useMutation } from 'react-query';
import { RouterInput, trpc } from '../../../../lib/trpc';
import { uploadToAws } from '../../../project-templates/hooks/ContentInformation/uploadToAws';

export default function useUploadProjectDocuments() {
    return useMutation(
        async ({
            files,
            projectId,
            documentType,
        }: {
            files: File[];
            projectId: number;
            documentType?: RouterInput['BindersApi']['uploadProjectDocument']['documentType'];
        }) => {
            const responses = files.map(async (file) => {
                const fileToSave = {
                    name: file.name,
                    size: file.size,
                    type: file.type,
                };

                const response = await trpc.BindersApi.uploadProjectDocument.mutate({
                    file: fileToSave,
                    projectId,
                    documentType: documentType,
                });

                if (response) {
                    await uploadToAws({
                        preSingedUrl: response.preSingedUrl,
                        file,
                        cleanup: async () => {
                            await trpc.BindersApi.removeProjectDocument.mutate({
                                id: response.id,
                                projectId,
                            });
                        },
                    });
                }
            });
            return await Promise.all(responses);
        },
    );
}
